import { render, staticRenderFns } from "./upLoad.vue?vue&type=template&id=f13e622a&scoped=true"
import script from "./upLoad.vue?vue&type=script&lang=ts"
export * from "./upLoad.vue?vue&type=script&lang=ts"
import style0 from "./upLoad.vue?vue&type=style&index=0&id=f13e622a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13e622a",
  null
  
)

export default component.exports